import { ThemeProvider } from 'styled-components';
import { DEFAULT_THEME, NEXT_THEME, NEXT_THEME_DARK_SCHEME } from '../../theming';
import { useHDSFeaturesContext } from './HDSFeaturesContext';
import { jsx as _jsx } from "react/jsx-runtime";
function getTheme(features) {
  if (features.nextThemeEnabled) {
    return features.darkColorSchemeEnabled ? NEXT_THEME_DARK_SCHEME : NEXT_THEME;
  }
  return DEFAULT_THEME;
}
export const HDSThemeProvider = ({
  children,
  theme
}) => {
  const features = useHDSFeaturesContext();
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme || getTheme(features),
    children: children
  });
};